import angular from 'angular';

angular.module('folkeuni').factory('NavigationApi', function ($http) {
  var self = this;
  var apiBase = '/umbraco/api/navigation/';

  self.getNavigation = function (rootId) {
      return $http({
          method: 'get',
          url: apiBase + 'getnavigationitems?rootId=' + rootId
      });
  };

  return self;
});
